// extracted by mini-css-extract-plugin
export default {"labeledCheckbox":"LabeledCheckbox_labeledCheckbox__detUK","checkbox":"LabeledCheckbox_checkbox__vdY2e","checked":"LabeledCheckbox_checked__0BcEs"};